<template lang="pug">
.k-tour-get-started.brand-dark-blue.white--text
  k-card-text(large)
    v-row(justify="center")
      v-col(lg="5" sm="6" cols="12")
        h2.title--36.font-family--secondary.font-weight-bold Get started with Kintell
        .paragraph.py-10.faded--8 Kintell is a great way of getting one-to-one video advice on pretty much any topic you can imagine. Whether you're looking to learn a language, or sell some land, we have an advisor who can help you with that.
        k-button(to="/search").mx-0 Browse advisors
      v-col(cols="6").hidden-xs-only
        v-img(:src="people" alt="" height="400" width="500" contain).k-tour-get-started__img.hidden-xs-only
</template>

<script>
export default {
  data () {
    return {
      people: require('~kurfs/girl-and-boy.svg')
    }
  }
}
</script>

<style scoped lang="scss">
.k-tour-get-started {
  position: relative;
  overflow: hidden;

  .title--regular {
    @include md-and-up {
      font-size: 36px !important;
    }
  }

  &__img {
    position: absolute;
    bottom: -10px;
    right: 0;
    width: 50% !important;

    @include sm-and-down {
      bottom: -60px;
    }
  }
}
</style>
